// PARÀMETRES DE CONNEXIÓ
const constants = {
  server: 'https://api.prom.sonespases.es/', // Casa. ALERTA: Si pos localhost, des d'altres ordinadors de la xarxa no poden fer login per un tema de CORS
  //server: 'http://82.223.234.1:3001/', // Arsys
  // server: 'http://10.215.216.161:3001/', // Oficina - Meu
  // server: 'https://rest.healthtrackerpre.play4health.com/', // PRE
  // server: 'https://api.prom.sonespases.es/', //PROD
  // server: 'http://tm.play4health.com/', // PROD
  // server: 'http://192.168.0.12:3001/', // Casa
  // server: 'http://192.168.57.23:3001/', // Erroni
  // server: 'http://10.215.216.165:3001/', // Local - IP Neus
  // server : 'http://192.168.0.12:3001/', // Local - IP Neus casa

  

};
export const serverAction = `${constants.server}action/`;
export const serverClinicians = `${constants.server}api/clinicians/`;
export const serverEventTypes = `${constants.server}api/event-types/`;
export const serverEnrolments = `${constants.server}api/enrolments/`;
export const serverInclusionCriterias = `${constants.server}api/inclusion-criteria/`;
export const serverLogin = `${constants.server}api/users/login`;
// export const serverPassword = `${constants.server}action/password-reset/link/`;
export const serverPatients = `${constants.server}api/patients/`;
export const serverPrograms = `${constants.server}api/programs/`;
export const serverResultSet = `${constants.server}api/result-sets/`;
export const serverSchedulingPatterns = `${constants.server}api/scheduling-patterns/`;
export const serverStatistics = `${constants.server}api/statistics/`;
export const serverUsers = `${constants.server}api/users/`;
export const serverUserSchedules = `${constants.server}api/user-schedules/`;
export const serverVariables = `${constants.server}api/variables/`;
export const timeToWait = 120000; // Temps de espera de la resposta del servidor en milisegons
export const timeToWarn = 5; // Minuts que falten per a que caduqui el token. Ho empram per avisar de que el token caducarà aviat
export const timeToConsultTokenExpiration = 60000; // Temps entra cada consulta de la caducitat del token, està en milisegons

export const maxAttempts = 5; // Nombre màxim d'intents per a fer login. Confirmar que concideix amb el que hi ha a l'app.js de l'arrel del projecte
export const timeUntilNewAttempt = 15; // Minuts que s'ha de esperar per a tornar a intentar fer login. Confirmar que concideix amb el que hi ha a l'app.js de l'arrel del projecte